export interface Employee {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  creation_date: Date;
  update_date: Date;
  email_verified: boolean;
  nursing_home_employees: NursingHomeEmployee[];
  resource_associations?: {
    resident?: Array<{
      resident_ids: string[];
      role: string;
    }>;
    nursing_home?: Array<{
      nursing_home_id: string;
      role: string;
    }>;
    tenant?: Array<{
      role: string;
    }>;
  };
}

/**
 * Whether the employee holds a tenant-wide admin association, which supersedes
 * any nursing-home role they may also have (ENG-2580).
 *
 * @example
 * isEmployeeTenantAdmin(employee) // => true
 */
export const isEmployeeTenantAdmin = (
  employee: Pick<Employee, 'resource_associations'> | undefined
): boolean =>
  Boolean(
    employee?.resource_associations?.tenant?.some(
      (association) => association.role === 'admin'
    )
  );

enum EmployeeState {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending',
}

interface NursingHomeEmployee {
  employee_state: EmployeeState;
  nursing_home_id: string;
  is_supervisor: boolean;
  roles_manually_assigned: boolean;
  email_notifications: boolean;
}

export interface UpdateEmployee {
  employee_id: string;
  employee?: {
    id: string;
    first_name?: string;
    last_name?: string;
  };
  employee_state?: EmployeeState;
  is_supervisor?: boolean;
  roles_manually_assigned?: boolean;
  email_notifications?: boolean;
  resource_associations?: ResourceAssociation[];
}

export interface ResourceAssociation {
  resource_type: string;
  resource_ids?: string[];
  role_id: string;
}

export interface AddEmployee {
  first_name: string;
  last_name: string;
  email: string;
}
